module.exports = __webpack_public_path__ + "img/search_lens.b23ff9ce.svg";